import Icon from '@ant-design/icons';
import type { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';

const ErosionOutlinedSvg = () => (
  <svg
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.9}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M3 5.5L21 9.6L20.3 11.5Q12.5 17.4 3 18.5Z" />
    <path
      d="M3 5.5L18.8 9.1L16.4 11.75L14.4 9.9L11.6 11.46L9 8.87L6.2 9.83L3 7.9Z"
      fill="currentColor"
      stroke="none"
    />
  </svg>
);

export const ErosionOutlined = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={ErosionOutlinedSvg} {...props} />
);
